import { AppId } from '@inno-tools/container-bridge'
import { useAvailableApps } from 'modules/app-registry/hooks/useAvailableApps'
import { useLocation, useNavigate } from 'react-router-dom'
import { useUserContext } from 'shared/hooks'

import { FullPageAppTemplate } from '../../templates'

export const IntegrationAppV2 = () => {
  const location = useLocation()
  const navigate = useNavigate()
  const { user } = useUserContext()
  const { apps } = useAvailableApps()

  return (
    <FullPageAppTemplate
      appId={AppId.INTEGRATION_V2}
      scope='integration_v2'
      envKey={apps[AppId.INTEGRATION_V2]?.runtimeEnvKey}
      entryPath='./IntegrationAppV2'
      url={process.env.REACT_APP_INTEGRATION_V2_APP_DEV_PATH}
      appName={apps[AppId.INTEGRATION_V2]?.name}
      appProps={{
        user,
        initialPath: apps[AppId.INTEGRATION_V2]?.path,
        onNavigate: ({ pathname: nextPathname }: { pathname: string }) => {
          const { pathname } = location

          if (pathname !== nextPathname) {
            navigate(nextPathname)
          }
        }
      }}
    />
  )
}
